import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteMultipleContaReceber } from '../service';
import {
  DELETE_MULTIPLE_CONTA_RECEBER,
  DELETE_MULTIPLE_CONTA_RECEBER_PENDING,
  DELETE_MULTIPLE_CONTA_RECEBER_SUCCESS,
  DELETE_MULTIPLE_CONTA_RECEBER_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'

function* sagaDeleteMultipleContaReceber(action) {
  yield put({ type: DELETE_MULTIPLE_CONTA_RECEBER_PENDING, ids: action.ids });

  try {
    const a = yield call(deleteMultipleContaReceber, action.ids);

    if (a.status !== 204) {
      // Lança o erro original para preservar a resposta do backend
      throw a;
    }
    yield put({ type: DELETE_MULTIPLE_CONTA_RECEBER_SUCCESS, ids: action.ids });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {
    yield put({ type: DELETE_MULTIPLE_CONTA_RECEBER_FAILURE });

    // Verifica se é o erro específico de OFX (status 409)
    // O erro pode vir em diferentes estruturas dependendo de como o httpService retorna
    const errorMessage = error?.response?.data?.message || error?.data?.message;
    const errorStatus = error?.response?.status || error?.status;

    if (errorStatus === 409 && errorMessage && errorMessage.includes('conciliada com transação bancária (OFX)')) {
      AlertError(errorMessage);
    } else {
      AlertError('Falha ao excluir os registros! Verifique se a conta não possui vínculo com outra conta gerencial ou em lançamentos no financeiro.');
    }
  }
}

export default function* watchDeleteMultipleContaReceber() {
  yield takeLatest(DELETE_MULTIPLE_CONTA_RECEBER, sagaDeleteMultipleContaReceber)
}
